import { useTranslation } from 'react-i18next';

import { LostDamagedPalletsByClientItem } from 'interfaces';
import { currencyFormatter } from 'utils/numberFormatter';

import styles from '../AdditionalFeeWarning.module.css';

type AdditionalFeeListItemProps = {
   element: LostDamagedPalletsByClientItem;
};

const AdditionalFeeListItem = ({ element }: AdditionalFeeListItemProps) => {
   const { t } = useTranslation();

   const totalAdditionalFee = currencyFormatter.format(
      +element.palletsAmount * +element.reportPrice!,
   );

   return (
      <li className={styles.additionalFeeListItem}>
         {t('additionalFeeSection.listItem', {
            palletType: element.palletType.label,
            unitPrice: currencyFormatter.format(element.reportPrice!),
            amount: element.palletsAmount,
            total: totalAdditionalFee,
         })}
      </li>
   );
};

export default AdditionalFeeListItem;
